import { render, staticRenderFns } from "./TabWithdrawPending.vue?vue&type=template&id=1beafffa&scoped=true&"
import script from "./TabWithdrawPending.vue?vue&type=script&lang=js&"
export * from "./TabWithdrawPending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1beafffa",
  null
  
)

export default component.exports